// extracted by mini-css-extract-plugin
export default {"banners":"BannersComponent_banners__XNsGS"};